import { createFileRoute } from '@tanstack/react-router'

import { HealthInsurancePageSkeleton } from '#/modules/health/front-office/health-insurance-page/health-insurance-page-skeleton.tsx'
import { HealthInsurancePage } from '#/modules/health/front-office/health-insurance-page/health-insurance-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'

export const Route = createFileRoute('/(customer)/_shell/health-insurance-v2/')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      context.trpc.contracts.listMyContracts.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
    ),
  pendingComponent: HealthInsurancePageSkeleton,
  pendingMs: 150,
  component: HealthInsurancePage,
})
